import React, { ReactNode } from "react";
import styles from "./TwoColLayout.module.css";

interface TwoColLayoutProps {
    leftContent?: ReactNode,
    rightContent?: ReactNode
}

const TwoColLayout = ({ leftContent, rightContent }: TwoColLayoutProps) => {
    return (
        <div className={styles['inner-grid-wrapper']}>
            <div className={styles['layout-grid-container']}>
                <div className={styles["layout-col01"]}>
                    {leftContent}
                </div>
                {rightContent && <div className={styles["layout-col02"]}>
                    {rightContent}
                </div>}

            </div>
        </div>
    )
}

export default TwoColLayout;
